// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* some code copied and modified from https://github.com/microsoft/vscode/blob/1.49.3/src/vs/workbench/contrib/comments/browser/media/review.css */

.comment-range-glyph {
    margin-left: 5px;
    cursor: pointer;
}
.comment-range-glyph:before {
    position: absolute;
    content: '';
    height: 100%;
    width: 0;
    left: -2px;
    transition: width 80ms linear, left 80ms linear;
}

.monaco-editor .margin-view-overlays > div:hover > .comment-range-glyph.comment-diff-added:before,
.monaco-editor .comment-range-glyph.comment-thread:before {
    position: absolute;
    height: 100%;
    width: 9px;
    left: -6px;
    z-index: 10;
    color: black;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.monaco-editor .comment-diff-added {
    border-left: 3px solid var(--theia-editorGutter-commentRangeForeground);
    transition: opacity 0.5s;
}
.monaco-editor .comment-diff-added:before {
    background: var(--theia-editorGutter-commentRangeForeground);
}

.monaco-editor .margin-view-overlays > div:hover > .comment-range-glyph.comment-diff-added:before {
    content: "+";
}

.monaco-editor .comment-range-glyph.comment-thread {
    z-index: 20;
    border-left: 3px solid #000;
}

.monaco-editor .comment-thread:before {
    background: var(--theia-editorGutter-commentRangeForeground);
}

.monaco-editor .comment-range-glyph.comment-thread:before {
    content: "◆";
    font-size: 10px;
    line-height: 100%;
    z-index: 20;
}

.monaco-editor .review-widget .body {
    overflow: hidden;
}

.monaco-editor .review-widget .head {
    box-sizing: border-box;
    display: flex;
    height: 100%;
}

.monaco-editor .review-widget .head .review-title {
    display: inline-block;
    font-size: 13px;
    margin-left: 20px;
    cursor: default;
}

.monaco-editor .review-widget .head .review-actions {
    flex: 1;
    text-align: right;
    padding-right: 2px;
}

.monaco-editor .review-widget .head .review-actions > .monaco-action-bar {
    display: inline-block;
}

.monaco-editor .review-widget .head .review-actions > .monaco-action-bar,
.monaco-editor .review-widget .head .review-actions > .monaco-action-bar > .actions-container {
    height: 100%;
}

.monaco-editor .review-widget .action-item {
    min-width: 18px;
    min-height: 20px;
    margin-left: 4px;
}

.monaco-editor .review-widget .head .review-actions > .monaco-action-bar .action-label {
    width: 16px;
    height: 100%;
    margin: 0;
    color: var(--theia-editorWidget-foreground);
    line-height: inherit;
    background-repeat: no-repeat;
    background-position: center center;
}

.monaco-editor .review-widget>.body {
    border-top: 1px solid;
    position: relative;
}

.monaco-editor .review-widget .body .comment-form {
    margin: 8px 20px;
}

.monaco-editor .review-widget .body .review-comment {
    padding: 8px 16px 8px 20px;
    display: flex;
}

.monaco-editor .review-widget .body .review-comment .avatar-container {
    margin-top: 4px !important;
}

.monaco-editor .review-widget .body .review-comment .avatar-container img.avatar {
    height: 28px;
    width: 28px;
    display: inline-block;
    overflow: hidden;
    line-height: 1;
    vertical-align: middle;
    border-radius: 3px;
    border-style: none;
}

.monaco-editor .review-widget .body .review-comment .review-comment-contents {
    padding-left: 20px;
    user-select: text;
    -webkit-user-select: text;
    width: 100%;
    overflow: hidden;
}

.monaco-editor .review-widget .body .review-comment .review-comment-contents .author {
    line-height: var(--theia-content-line-height);
}

.monaco-editor .review-widget .body .review-comment .review-comment-contents .timestamp {
    line-height: var(--theia-content-line-height);
    margin: 0 5px 0 5px;
    padding: 0 2px 0 2px;
}

.monaco-editor .review-widget .body .review-comment .review-comment-contents .isPending {
    margin: 0 5px 0 5px;
    padding: 0 2px 0 2px;
    font-style: italic;
}

.monaco-editor .review-widget .body .review-comment .review-comment-contents .comment-body {
    padding-top: 4px;
}

.monaco-editor .review-widget .body .review-comment .comment-title {
    display: flex;
    width: 100%;
}

.monaco-editor .review-widget .body .comment-form .theia-comments-input-message-container {
    display: none;
}

.monaco-editor .review-widget .body .comment-form.expand .theia-comments-input-message-container,
.edit-textarea .theia-comments-input-message-container {
    display: flex;
    flex-direction: column;
    margin: 0px 0px 7px 0px;
    max-height: 400px;
}

.monaco-editor .review-widget .body .comment-form.expand .theia-comments-input-message-container textarea,
.edit-textarea .theia-comments-input-message-container textarea {
    line-height: var(--theia-content-line-height);
    background: var(--theia-editor-background);
    resize: none;
    height: 90px;
    box-sizing: border-box;
    min-height: 32px;
    padding: 4px;
    border: none;
}

.monaco-editor .review-widget .body .comment-form.expand .theia-comments-input-message-container textarea:placeholder-shown,
.edit-textarea .theia-comments-input-message-container textarea:placeholder-shown {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.monaco-editor .review-widget .body .comment-form.expand .theia-comments-input-message-container textarea:not(:focus),
.edit-textarea .theia-comments-input-message-container textarea:not(:focus) {
    border: var(--theia-border-width) solid var(--theia-editor-background);
}

.monaco-editor .review-widget .body .comment-form.expand .theia-comments-input-message-container textarea:focus,
.edit-textarea .theia-comments-input-message-container textarea:focus {
    border: var(--theia-border-width) solid var(--theia-focusBorder);
}

.theia-comments-input-message {
    width: 100%;
}

.monaco-editor .review-widget .body .comment-body p,
.monaco-editor .review-widget .body .comment-body ul {
    margin: 8px 0;
}

.monaco-editor .review-widget .body .comment-body p:first-child,
.monaco-editor .review-widget .body .comment-body ul:first-child {
    margin-top: 0;
}

.monaco-editor .review-widget .body .comment-body p:last-child,
.monaco-editor .review-widget .body.comment-body ul:last-child {
    margin-bottom: 0;
}

.monaco-editor .review-widget .body .comment-body ul {
    padding-left: 20px;
}

.monaco-editor .review-widget .body .comment-body li > p {
    margin-bottom: 0;
}

.monaco-editor .review-widget .body .comment-body li > ul {
    margin-top: 0;
}

.monaco-editor .review-widget .body .comment-body code {
    border-radius: 3px;
    padding: 0 0.4em;
}

.monaco-editor .review-widget .body .comment-body span {
    white-space: pre;
}

.monaco-editor .review-widget .body .comment-body img {
    max-width: 100%;
}

.monaco-editor .review-widget .body .comment-form .form-actions {
    display: none;
}

.monaco-editor .review-widget .body .comment-form.expand .form-actions {
    display: block;
    box-sizing: content-box;
}

.monaco-editor .review-widget .body .comment-form.expand .review-thread-reply-button {
    display: none;
}

.monaco-editor .review-widget .body .comment-form .review-thread-reply-button {
    text-align: left;
    display: block;
    width: 100%;
    resize: vertical;
    background: var(--theia-editor-background);
    color: var(--theia-input-foreground);
    cursor: text;
    font-size: var(--theia-ui-font-size1);
    border-radius: 0;
    box-sizing: border-box;
    padding: 6px 12px;
    font-weight: 600;
    line-height: 20px;
    white-space: nowrap;
    border: 0px;
    outline: 1px solid transparent;
}

.monaco-editor .review-widget .body .comment-form .review-thread-reply-button:focus {
    outline-style: solid;
    outline-width: 1px;
}

.monaco-editor .review-widget .body .comment-form.expand .form-actions,
.monaco-editor .review-widget .body .edit-container .form-actions {
    overflow: auto;
    padding: 10px 0;
}

.monaco-editor .review-widget .body .edit-container .form-actions {
    display: flex;
    justify-content: flex-end;
}

.monaco-editor .review-widget .body .edit-textarea {
    margin: 5px 0 10px 0;
}

.monaco-editor .review-widget .body .comment-form.expand .comments-text-button,
.monaco-editor .review-widget .body .edit-container .comments-text-button {
    width: auto;
    padding: 4px 10px;
    margin-left: 5px;
    margin-bottom: 5px;
}

.monaco-editor .review-widget .body .comment-form.expand .comments-text-button {
    float: right;
}

.theia-comments-inline-actions-container {
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
    min-height: 16px;
}

.theia-comments-inline-actions {
    display: flex;
    margin: 0 3px;
}

.theia-comments-inline-actions a {
    color: var(--theia-icon-foreground);
}

.theia-comments-inline-action {
    padding: 0px 3px;
    font-size: var(--theia-ui-font-size1);
    margin: 0 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/plugin-ext/src/main/browser/style/comments.css"],"names":[],"mappings":"AAAA;;;+FAG+F;AAC/F,kJAAkJ;;AAElJ;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,+CAA+C;AACnD;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uEAAuE;IACvE,wBAAwB;AAC5B;AACA;IACI,4DAA4D;AAChE;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,2CAA2C;IAC3C,oBAAoB;IACpB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;IAEI,6CAA6C;IAC7C,0CAA0C;IAC1C,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,sEAAsE;AAC1E;;AAEA;;IAEI,gEAAgE;AACpE;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,0CAA0C;IAC1C,oCAAoC;IACpC,YAAY;IACZ,qCAAqC;IACrC,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,aAAa;IACb,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB","sourcesContent":["/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n/* some code copied and modified from https://github.com/microsoft/vscode/blob/1.49.3/src/vs/workbench/contrib/comments/browser/media/review.css */\n\n.comment-range-glyph {\n    margin-left: 5px;\n    cursor: pointer;\n}\n.comment-range-glyph:before {\n    position: absolute;\n    content: '';\n    height: 100%;\n    width: 0;\n    left: -2px;\n    transition: width 80ms linear, left 80ms linear;\n}\n\n.monaco-editor .margin-view-overlays > div:hover > .comment-range-glyph.comment-diff-added:before,\n.monaco-editor .comment-range-glyph.comment-thread:before {\n    position: absolute;\n    height: 100%;\n    width: 9px;\n    left: -6px;\n    z-index: 10;\n    color: black;\n    text-align: center;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.monaco-editor .comment-diff-added {\n    border-left: 3px solid var(--theia-editorGutter-commentRangeForeground);\n    transition: opacity 0.5s;\n}\n.monaco-editor .comment-diff-added:before {\n    background: var(--theia-editorGutter-commentRangeForeground);\n}\n\n.monaco-editor .margin-view-overlays > div:hover > .comment-range-glyph.comment-diff-added:before {\n    content: \"+\";\n}\n\n.monaco-editor .comment-range-glyph.comment-thread {\n    z-index: 20;\n    border-left: 3px solid #000;\n}\n\n.monaco-editor .comment-thread:before {\n    background: var(--theia-editorGutter-commentRangeForeground);\n}\n\n.monaco-editor .comment-range-glyph.comment-thread:before {\n    content: \"◆\";\n    font-size: 10px;\n    line-height: 100%;\n    z-index: 20;\n}\n\n.monaco-editor .review-widget .body {\n    overflow: hidden;\n}\n\n.monaco-editor .review-widget .head {\n    box-sizing: border-box;\n    display: flex;\n    height: 100%;\n}\n\n.monaco-editor .review-widget .head .review-title {\n    display: inline-block;\n    font-size: 13px;\n    margin-left: 20px;\n    cursor: default;\n}\n\n.monaco-editor .review-widget .head .review-actions {\n    flex: 1;\n    text-align: right;\n    padding-right: 2px;\n}\n\n.monaco-editor .review-widget .head .review-actions > .monaco-action-bar {\n    display: inline-block;\n}\n\n.monaco-editor .review-widget .head .review-actions > .monaco-action-bar,\n.monaco-editor .review-widget .head .review-actions > .monaco-action-bar > .actions-container {\n    height: 100%;\n}\n\n.monaco-editor .review-widget .action-item {\n    min-width: 18px;\n    min-height: 20px;\n    margin-left: 4px;\n}\n\n.monaco-editor .review-widget .head .review-actions > .monaco-action-bar .action-label {\n    width: 16px;\n    height: 100%;\n    margin: 0;\n    color: var(--theia-editorWidget-foreground);\n    line-height: inherit;\n    background-repeat: no-repeat;\n    background-position: center center;\n}\n\n.monaco-editor .review-widget>.body {\n    border-top: 1px solid;\n    position: relative;\n}\n\n.monaco-editor .review-widget .body .comment-form {\n    margin: 8px 20px;\n}\n\n.monaco-editor .review-widget .body .review-comment {\n    padding: 8px 16px 8px 20px;\n    display: flex;\n}\n\n.monaco-editor .review-widget .body .review-comment .avatar-container {\n    margin-top: 4px !important;\n}\n\n.monaco-editor .review-widget .body .review-comment .avatar-container img.avatar {\n    height: 28px;\n    width: 28px;\n    display: inline-block;\n    overflow: hidden;\n    line-height: 1;\n    vertical-align: middle;\n    border-radius: 3px;\n    border-style: none;\n}\n\n.monaco-editor .review-widget .body .review-comment .review-comment-contents {\n    padding-left: 20px;\n    user-select: text;\n    -webkit-user-select: text;\n    width: 100%;\n    overflow: hidden;\n}\n\n.monaco-editor .review-widget .body .review-comment .review-comment-contents .author {\n    line-height: var(--theia-content-line-height);\n}\n\n.monaco-editor .review-widget .body .review-comment .review-comment-contents .timestamp {\n    line-height: var(--theia-content-line-height);\n    margin: 0 5px 0 5px;\n    padding: 0 2px 0 2px;\n}\n\n.monaco-editor .review-widget .body .review-comment .review-comment-contents .isPending {\n    margin: 0 5px 0 5px;\n    padding: 0 2px 0 2px;\n    font-style: italic;\n}\n\n.monaco-editor .review-widget .body .review-comment .review-comment-contents .comment-body {\n    padding-top: 4px;\n}\n\n.monaco-editor .review-widget .body .review-comment .comment-title {\n    display: flex;\n    width: 100%;\n}\n\n.monaco-editor .review-widget .body .comment-form .theia-comments-input-message-container {\n    display: none;\n}\n\n.monaco-editor .review-widget .body .comment-form.expand .theia-comments-input-message-container,\n.edit-textarea .theia-comments-input-message-container {\n    display: flex;\n    flex-direction: column;\n    margin: 0px 0px 7px 0px;\n    max-height: 400px;\n}\n\n.monaco-editor .review-widget .body .comment-form.expand .theia-comments-input-message-container textarea,\n.edit-textarea .theia-comments-input-message-container textarea {\n    line-height: var(--theia-content-line-height);\n    background: var(--theia-editor-background);\n    resize: none;\n    height: 90px;\n    box-sizing: border-box;\n    min-height: 32px;\n    padding: 4px;\n    border: none;\n}\n\n.monaco-editor .review-widget .body .comment-form.expand .theia-comments-input-message-container textarea:placeholder-shown,\n.edit-textarea .theia-comments-input-message-container textarea:placeholder-shown {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.monaco-editor .review-widget .body .comment-form.expand .theia-comments-input-message-container textarea:not(:focus),\n.edit-textarea .theia-comments-input-message-container textarea:not(:focus) {\n    border: var(--theia-border-width) solid var(--theia-editor-background);\n}\n\n.monaco-editor .review-widget .body .comment-form.expand .theia-comments-input-message-container textarea:focus,\n.edit-textarea .theia-comments-input-message-container textarea:focus {\n    border: var(--theia-border-width) solid var(--theia-focusBorder);\n}\n\n.theia-comments-input-message {\n    width: 100%;\n}\n\n.monaco-editor .review-widget .body .comment-body p,\n.monaco-editor .review-widget .body .comment-body ul {\n    margin: 8px 0;\n}\n\n.monaco-editor .review-widget .body .comment-body p:first-child,\n.monaco-editor .review-widget .body .comment-body ul:first-child {\n    margin-top: 0;\n}\n\n.monaco-editor .review-widget .body .comment-body p:last-child,\n.monaco-editor .review-widget .body.comment-body ul:last-child {\n    margin-bottom: 0;\n}\n\n.monaco-editor .review-widget .body .comment-body ul {\n    padding-left: 20px;\n}\n\n.monaco-editor .review-widget .body .comment-body li > p {\n    margin-bottom: 0;\n}\n\n.monaco-editor .review-widget .body .comment-body li > ul {\n    margin-top: 0;\n}\n\n.monaco-editor .review-widget .body .comment-body code {\n    border-radius: 3px;\n    padding: 0 0.4em;\n}\n\n.monaco-editor .review-widget .body .comment-body span {\n    white-space: pre;\n}\n\n.monaco-editor .review-widget .body .comment-body img {\n    max-width: 100%;\n}\n\n.monaco-editor .review-widget .body .comment-form .form-actions {\n    display: none;\n}\n\n.monaco-editor .review-widget .body .comment-form.expand .form-actions {\n    display: block;\n    box-sizing: content-box;\n}\n\n.monaco-editor .review-widget .body .comment-form.expand .review-thread-reply-button {\n    display: none;\n}\n\n.monaco-editor .review-widget .body .comment-form .review-thread-reply-button {\n    text-align: left;\n    display: block;\n    width: 100%;\n    resize: vertical;\n    background: var(--theia-editor-background);\n    color: var(--theia-input-foreground);\n    cursor: text;\n    font-size: var(--theia-ui-font-size1);\n    border-radius: 0;\n    box-sizing: border-box;\n    padding: 6px 12px;\n    font-weight: 600;\n    line-height: 20px;\n    white-space: nowrap;\n    border: 0px;\n    outline: 1px solid transparent;\n}\n\n.monaco-editor .review-widget .body .comment-form .review-thread-reply-button:focus {\n    outline-style: solid;\n    outline-width: 1px;\n}\n\n.monaco-editor .review-widget .body .comment-form.expand .form-actions,\n.monaco-editor .review-widget .body .edit-container .form-actions {\n    overflow: auto;\n    padding: 10px 0;\n}\n\n.monaco-editor .review-widget .body .edit-container .form-actions {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.monaco-editor .review-widget .body .edit-textarea {\n    margin: 5px 0 10px 0;\n}\n\n.monaco-editor .review-widget .body .comment-form.expand .comments-text-button,\n.monaco-editor .review-widget .body .edit-container .comments-text-button {\n    width: auto;\n    padding: 4px 10px;\n    margin-left: 5px;\n    margin-bottom: 5px;\n}\n\n.monaco-editor .review-widget .body .comment-form.expand .comments-text-button {\n    float: right;\n}\n\n.theia-comments-inline-actions-container {\n    display: flex;\n    justify-content: flex-end;\n    margin-left: auto;\n    min-height: 16px;\n}\n\n.theia-comments-inline-actions {\n    display: flex;\n    margin: 0 3px;\n}\n\n.theia-comments-inline-actions a {\n    color: var(--theia-icon-foreground);\n}\n\n.theia-comments-inline-action {\n    padding: 0px 3px;\n    font-size: var(--theia-ui-font-size1);\n    margin: 0 2px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
